import * as PIXI from "pixi.js";
import { UIButton } from "./UIButton";

export class AutoplayPopup extends PIXI.Container {
    private background: PIXI.Graphics;
    private buttons: UIButton[] = [];
    private reels: number;
    private selectedButton: UIButton | null = null;

    constructor(reels: number) {
        super();
        this.reels = reels;

        const width = 500;
        const height = 700;
        const title = new PIXI.Text({
            text: "Autoplay",
            style: {
                fill: "0xff8531",
                fontWeight: "bold",
                fontSize: 30,
            }
        });
        title.anchor.set(0.5);
        title.y = -300;
        // Create the popup background
        this.background = new PIXI.Graphics();
        this.background.roundRect(-width / 2, -height / 2, width, height, 20); // Rounded rectangle
        this.background.fill(0x000000); // Dark gray
        this.background.alpha = 0.85;
        this.background.interactive = true;

        this.addChild(this.background);
        this.addChild(title);
    }

    // Method to set bet amounts dynamically
    public setData(data: number[]): void {
        // Clear existing buttons
        this.buttons.forEach((button) => this.removeChild(button));
        this.buttons = [];

        // Determine rows based on the number of bets and fixed reels
        const rows = Math.ceil(data.length / this.reels);

        const padding = 20; // Padding between buttons
        const buttonWidth = UIButton.WIDTH;
        const buttonHeight = UIButton.HEIGHT;

        // Calculate total width of the buttons and padding for horizontal centering
        const totalWidth = this.reels * buttonWidth + (this.reels - 1) * padding;
        const startX = -totalWidth / 2 + buttonWidth / 2; // Center horizontally by adjusting X position

        // Calculate the vertical start position to center the buttons
        const totalHeight = rows * buttonHeight + (rows - 1) * padding;
        const startY = -totalHeight / 2 + 50; // Center vertically by adjusting Y position

        // Create buttons dynamically based on bets array
        data.forEach((amount, index) => {
            const row = Math.floor(index / this.reels);
            const col = index % this.reels;

            const x = startX + col * (buttonWidth + padding);
            const y = startY + row * (buttonHeight + padding);

            let text = amount.toString();
            if (amount === -1) {
                text = '\u221E';
            }
            const button = new UIButton(text);
            button.setData(amount);
            button.position.set(x, y);

            // Listen to the 'onSelect' event for each button
            button.on('onSelect', this.onBetButtonSelect, this);

            this.addChild(button);
            this.buttons.push(button);
        });
    }

    show () {
        if (this.selectedButton) {
            this.selectedButton.unselect();
        }
        this.visible = true;
    }

    hide () {
        this.visible = false;
    }

    // Handle bet button selection
    private onBetButtonSelect(selectedButton: UIButton): void {
        // If a button is already selected, unselect it
        if (this.selectedButton) {
            this.selectedButton.unselect();
        }
        this.selectedButton = selectedButton;
        this.selectedButton.select();
        this.emit('autoplaySelected', this.selectedButton.getData());
    }
}
